export enum CustomerExternalNumberSourceType {
  BOM = 'bom',
  CUSTOMER = 'customer',
  LOCATION = 'location',
}

export enum CustomerExternalNumberType {
  BOM = 'bom',
  CUSTOMER = 'customer',
  LOCATION = 'location',
  ORDER = 'order',
}
